
import Button from '../../../components/base/Button';

const releases = [
  {
    id: 1,
    title: 'あの雲のむこうがわ、その先に',
    subtitle: '久下暁雅デビューシングル　第１弾',
    releaseDate: '近日公開',
    genre: 'アコースティック・バラード',
    credits: {
      lyrics: '久下暁雅、瀬田一流',
      music: '瀬田一流',
      arrangement: '瀬田一流',
      producer: '瀬田一流'
    },
    image: 'https://readdy.ai/api/search-image?query=Acoustic%20singer-songwriter%20holding%20guitar%20in%20intimate%20studio%20setting%2C%20warm%20golden%20lighting%2C%20emotional%20expression%2C%20simple%20clean%20background%2C%20professional%20music%20photography%20style%2C%20soft%20and%20gentle%20atmosphere%2C%20close-up%20portrait%20composition&width=400&height=400&seq=single1-cover&orientation=squarish',
    description: '映画「キリコのタクト」の挿入歌オーディションのために急遽制作された楽曲。心に響くメロディーと詩的な歌詞が印象的なアコースティック・バラード。'
  },
  {
    id: 2,
    title: 'ナイト・フライト',
    subtitle: '新境地への挑戦',
    releaseDate: '近日公開',
    genre: 'ガレージロック',
    credits: {
      lyrics: '久下暁雅',
      music: '久下暁雅',
      arrangement: '瀬田一流',
      producer: '瀬田一流'
    },
    image: 'https://readdy.ai/api/search-image?query=Male%20guitarist%20embracing%20electric%20guitar%20in%20close-up%20composition%2C%20dark%20black%20background%2C%20dramatic%20backlighting%20creating%20silhouette%20effect%20around%20figure%20and%20guitar%2C%20psychedelic%2070s%20style%2C%20motion%20blur%20effect%2C%20artistic%20composition%20from%20guitar%20to%20upper%20body%20only%2C%20no%20feet%20visible%2C%20moody%20atmospheric%20lighting&width=400&height=400&seq=single2-cover-v2&orientation=squarish',
    description: '久下暁雅の新たな音楽的挑戦を示すガレージロック楽曲。力強いギターサウンドと情熱的な歌声が融合した、エネルギッシュな一曲。'
  }
];

const LatestReleaseSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">Latest Release</h2>
        
        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* 1曲目：あの雲のむこうがわ、その先に */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="aspect-square relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Acoustic%20ballad%20album%20cover%20with%20soft%20clouds%20in%20pastel%20sky%2C%20gentle%20sunlight%20breaking%20through%20clouds%2C%20dreamy%20ethereal%20atmosphere%2C%20minimalist%20design%20with%20warm%20golden%20and%20soft%20blue%20tones%2C%20peaceful%20and%20contemplative%20mood%2C%20cinematic%20movie%20soundtrack%20aesthetic&width=400&height=400&seq=acoustic-ballad-cover-v2&orientation=squarish"
                alt="あの雲のむこうがわ、その先に ジャケット"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-2 text-gray-800">あの雲のむこうがわ、その先に</h3>
              <p className="text-gray-600 mb-4">久下暁雅デビューシングル　第１弾</p>
              <div className="space-y-2 text-sm text-gray-700">
                <p><span className="font-semibold">作詞：</span>久下暁雅、瀬田一流</p>
                <p><span className="font-semibold">作曲・編曲・プロデュース：</span>瀬田一流</p>
                <p><span className="font-semibold">ジャンル：</span>アコースティック・バラード</p>
                <p><span className="font-semibold">リリース日：</span>近日公開</p>
              </div>
            </div>
          </div>

          {/* 2曲目：ナイト・フライト */}
          <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="aspect-square relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/edited_02bde1f40e682bb602937053e8f3b01e_89f9b502.jpg"
                alt="やさしさを栞にして ジャケット"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-2 text-gray-800">やさしさを栞にして</h3>
              <p className="text-gray-600 mb-4">大切にし過ぎて臆病になっていたあの頃を、無かったことにしないで</p>
              <div className="space-y-2 text-sm text-gray-700">
                <p><span className="font-semibold">作詞・作曲・編曲：</span>瀬田一流</p>
                <p><span className="font-semibold">プロデュース：</span>瀬田一流</p>
                <p><span className="font-semibold">ジャンル：</span>アコースティック・バラード</p>
                <p><span className="font-semibold">リリース日：</span>近日公開</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestReleaseSection;
